import crypto from "crypto";
import { ALGORITHM, ALGORITHM_KEY, ALGORITHM_IV } from "../config/configs";

export const encryptme = (req) => {
  try {
    const cipher = crypto.createCipheriv(
      ALGORITHM,
      ALGORITHM_KEY,
      ALGORITHM_IV
    );
    let encrypted = cipher.update(req, "utf8", "Base64");
    encrypted += cipher.final("Base64");
    return encrypted;
  } catch (err) {}
};

export const decryptme = (resp) => {
  try {
    if (resp) {
      const decipher = crypto.createDecipheriv(
        ALGORITHM,
        ALGORITHM_KEY,
        ALGORITHM_IV
      );
      let decrypted = decipher.update(resp, "Base64", "utf8");
      decrypted += decipher.final("utf8");
      return decrypted;
    } else {
      return false;
    }
  } catch (err) {}
};
